
        var i18n = require('cadenza/utils/i18n/i18n');
        module.exports = (function () {
          var messages = {"de":{"current-state-changed":"Aktueller Stand (basierend auf v{{version}})","current-state-unsaved":"Aktueller Stand","unavailable-value":"N/A"},"en":{"current-state-changed":"Current state (based on v{{version}})","current-state-unsaved":"Current state","unavailable-value":"N/A"}};
          return function () {
            return i18n.loaderI18n.apply(messages[window.Disy.language], arguments);
          };
        })();